import { render } from "./FeedbackCreate.vue?vue&type=template&id=11849985&scoped=true"
import script from "./FeedbackCreate.vue?vue&type=script&lang=js"
export * from "./FeedbackCreate.vue?vue&type=script&lang=js"

import "./FeedbackCreate.vue?vue&type=style&index=0&id=11849985&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11849985"]])

export default __exports__